module.exports = __webpack_public_path__ + "static/media/NvphCoolingFan.269730f3.webp";